import React, { useEffect, useState } from "react";
import { apiCall } from "../../utils/axiosService";
import { apiResponse } from "../../utils/apiResponse";
import { API_URL } from "../../utils/apiRoutes";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { validationRule } from "../../utils/constant";
import { checkValidation } from "../../utils/helper";
import deleteIcon from "../../Assets/Images/Action Icons/deleteaction.svg";
import addaction from "../../Assets/Images/FormCheck/plusIcon.png";
import Creatable, { useCreatable } from "react-select/creatable";
import { commonService } from "../../utils/commonService";

const SnapShotMailSetupModal = ({
    snapshotdetails,
    showModal,
    closeModal,
    apiCallResponse,
}) => {
    const userDetails = commonService.getLoginUserData();
    const [loading, setLoading] = useState(false);
    const [shotmailsetup, setshotmailsetup] = useState({
        snapshotmailsetupid: snapshotdetails.id,
        snapshotid: "",
        scheduletype: "",
        sendto: "",
        ispause: 0,
        scheduleon: "",
        noofprevdaysofcurrentdate: 0,
        sendtolist: [],
        propertyid: snapshotdetails.propertyid,
        runtime: "",
        timezone: "",
        pagetype: "",
        validationRule: [
            {
                fieldName: "snapshotid",
                rule: validationRule.required,
                message: "Snapshot is required",
            },
            {
                fieldName: "scheduletype",
                rule: validationRule.required,
                message: "Schedule type is required",
            },
            {
                fieldName: "sendto",
                rule: validationRule.required,
                message: "Send to is required",
            },
            {
                fieldName: "scheduleon",
                rule: validationRule.required,
                message: "Schedule on is required",
            },
            {
                fieldName: "noofprevdaysofcurrentdate",
                rule: validationRule.required,
                message: "As of date is number of previous days from current date",
            },
            {
                fieldName: "runtime",
                rule: validationRule.required,
                message: "Run time on is required",
            },
            {
                fieldName: "timezone",
                rule: validationRule.required,
                message: "Timezone on is required",
            },
        ],
        errorObj: {},
        isValidate: true,
    });

    const [userDropdownList, setUserDropdownList] = useState([]);
    const getUserDropDownList = async () => {
        let userDropDownListResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.UserManagement + API_URL.USER.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    email: "",
                    mobileno: "",
                    displayname: "",
                    firstname: "",
                    lastname: "",
                    statusterm: "",
                    isdefault: null,
                    search: "",
                },
            },
            false
        );

        let response = apiResponse(false, userDropDownListResponse);

        if (response?.isValidate) {
            let List = [];
            if (response?.data?.data) {
                for (let i = 0; i < response?.data?.data.length; i++) {
                    List.push({
                        value: response?.data?.data[i].email,
                        label:
                            response?.data?.data[i].firstname +
                            " " +
                            response?.data?.data[i].lastname +
                            " (" +
                            response?.data?.data[i].email +
                            ")",
                    });
                }
            }

            setUserDropdownList(List);
        }
    };

    const getsnapshotmailsetup = async () => {
        let snapshotDetailResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.SNAPSHOTMAILSETUP.GETBYID,

                body: {
                    id: parseInt(snapshotdetails.id),
                },
            },
            false
        );

        let response = apiResponse(false, snapshotDetailResponse);

        if (response?.isValidate) {
            let sendtolist = [];
            if (response?.data?.data?.sendto) {
                let l = response?.data?.data?.sendto.split(",");
                if (l && l.length > 0) {
                    l.map((item) => item && sendtolist.push(item));
                }
            }

            setshotmailsetup({
                snapshotmailsetupid: response?.data?.data?.snapshotmailsetupid,
                snapshotid: response?.data?.data?.snapshotid,
                pagetype: response?.data?.data?.pagetype,
                scheduletype: response?.data?.data?.scheduletype,
                sendto: response?.data?.data?.sendto,
                ispause: response?.data?.data?.ispause
                    ? response?.data?.data?.ispause
                        ? 1
                        : 0
                    : 0,
                scheduleon: response?.data?.data?.scheduleon,
                noofprevdaysofcurrentdate:
                    response?.data?.data?.noofprevdaysofcurrentdate,
                sendtolist: sendtolist,
                propertyid: response?.data?.data?.propertyid,
                runtime: response?.data?.data?.runtime,
                timezone: response?.data?.data?.timezone,
            });
        }
    };

    const [SnapsortDropdownList, setSnapsortDropdownList] = useState([]);
    const [timeZoneDropDownList, setTimeZoneDropDownList] = useState([]);

    const getAsideMenuList = async () => {
        setSnapsortDropdownList([]);
        let asideMenuListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.SNAPSHOT.GETMAILSCHEDULEMENULIST,
                body: {
                    modulenames: "Revenue",
                    propertyid: snapshotdetails.propertyid
                        ? snapshotdetails.propertyid
                        : 0,
                },
            },
            false
        );

        let response = apiResponse(false, asideMenuListResponse);

        if (response?.isValidate) {
            const groupedData = response?.data?.data.reduce((acc, item) => {
                if (!acc[item.category]) {
                    acc[item.category] = [];
                }
                acc[item.category].push(item);
                return acc;
            }, {});
            setSnapsortDropdownList(groupedData);

            //if (userDetails?.clientid === 1) {
            //    const groupedData = response?.data?.data.reduce((acc, item) => {
            //        if (!acc[item.category]) {
            //            acc[item.category] = [];
            //        }
            //        acc[item.category].push(item);
            //        return acc;
            //    }, {});
            //    setSnapsortDropdownList(groupedData);
            //}
            //else {
            //    const groupedData = response?.data?.data.reduce((acc, item) => {
            //        if (item.category !== "Portfolio") {
            //            if (!acc[item.category]) {
            //                acc[item.category] = [];
            //            }
            //            acc[item.category].push(item);
            //        }
            //        return acc;
            //    }, {});
            //    setSnapsortDropdownList(groupedData);
            //}



            /* setSnapsortDropdownList(response?.data?.data);*/
        }
    };

    const getTimeZoneMenuList = async () => {
        let asideMenuListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.PROJECT_TERM.GET_LIST_OF_TIME_ZONE,
                body: {},
            },
            false
        );

        let response = apiResponse(false, asideMenuListResponse);

        if (response?.isValidate) {
            setTimeZoneDropDownList(response?.data?.data);
        }
    };

    useEffect(() => {
        getAsideMenuList();
        getUserDropDownList();
        getsnapshotmailsetup();
        getTimeZoneMenuList();
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        let validation = checkValidation(shotmailsetup);

        if (!validation.isValidate) {
            setshotmailsetup(validation);
            setLoading(false);
            return;
        }

        const saveResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration + API_URL.SNAPSHOTMAILSETUP.SAVE,
                body: {
                    snapshotmailsetupid: shotmailsetup?.snapshotmailsetupid,
                    snapshotid: shotmailsetup?.snapshotid,
                    scheduletype: shotmailsetup?.scheduletype,
                    sendto: shotmailsetup?.sendto,
                    ispause: shotmailsetup?.ispause
                        ? shotmailsetup?.ispause === "0"
                            ? false
                            : true
                        : false,
                    scheduleon: shotmailsetup?.scheduleon,
                    noofprevdaysofcurrentdate: shotmailsetup?.noofprevdaysofcurrentdate,
                    propertyid: shotmailsetup?.propertyid,
                    runtime: shotmailsetup?.runtime,
                    timezone: shotmailsetup?.timezone,
                    pagetype: shotmailsetup?.pagetype,
                },
            },
            true
        );

        let response = apiResponse(true, saveResponse, setLoading);

        if (response?.isValidate) {
            setLoading(false);
            apiCallResponse()
            closeModal();
        }

        if (!response?.isValidate) {
            setLoading(false);
        }
    };
    const [selectedOption, setSelectedOption] = useState(null);
    const [invalidemail, setinvalidemail] = useState("");
    const handleChange = (newValue) => {
        setSelectedOption(newValue);
        setinvalidemail("");
    };

    const AddEmail = () => {
        if (selectedOption && selectedOption.value) {
            let v = {
                email: selectedOption.value,
                validationRule: [
                    {
                        fieldName: "email",
                        rule: validationRule.email,
                        message: "Enter valid email",
                    },
                ],
                errorObj: {},
                isValidate: true,
            };
            let validation = checkValidation(v);

            if (!validation.isValidate) {
                setinvalidemail("Enter valid email");
                setSelectedOption("");
                return;
            } else {
                if (shotmailsetup.sendto.indexOf(selectedOption.value) < 0) {
                    let email = shotmailsetup.sendto;
                    email = email + "," + selectedOption.value;
                    email = email.replaceAll(",,", ",");
                    email = email.replaceAll(" ", "");

                    let sendtolist = [];
                    if (email) {
                        let l = email.split(",");
                        if (l && l.length > 0) {
                            l.map((item) => item && sendtolist.push(item));
                        }
                    }

                    setshotmailsetup({
                        ...shotmailsetup,
                        sendto: email,
                        sendtolist: sendtolist,
                    });
                }
            }
            setSelectedOption("");
        }
    };

    const DeleteEmail = (emailfordelete) => {
        let sendtolist = [];
        let oldlist = Array.from(shotmailsetup.sendtolist);

        if (oldlist && oldlist.length > 0) {
            oldlist.map((item) => item !== emailfordelete && sendtolist.push(item));
        }
        let email = "";
        if (sendtolist && sendtolist.length > 0) {
            email = sendtolist.toString();
        }
        setshotmailsetup({
            ...shotmailsetup,
            sendto: email,
            sendtolist: sendtolist,
        });
    };
    return (
        <>
            <Modal
                className="EmailTempConfigModalMain"
                size="lg"
                centered
                show={showModal}
                onHide={closeModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Snapshot Email Schedule
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xl={12}>
                            <div className="flotingLableGroup">
                                <div className="from-groups no-border-break mb-3">
                                    <Form.Label>Snapshot</Form.Label>
                                    <Form.Select id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "snapshot", "")}
                                        aria-label="Default select example"
                                        value={shotmailsetup?.snapshotid}
                                        onChange={(e) => {
                                            const selectedOption = e.target.selectedOptions[0];

                                            setshotmailsetup({
                                                ...shotmailsetup,
                                                snapshotid: e.target.value,
                                                pagetype: selectedOption.getAttribute("pagetype"),
                                            });
                                        }}
                                    >
                                        <option value="">Select Snapshot</option>

                                        {Object.keys(SnapsortDropdownList).map((category) => (
                                            <optgroup label={category} key={category}>
                                                {SnapsortDropdownList[category].map((item) => (
                                                    <option
                                                        key={item.snapshotid}
                                                        value={item.snapshotid}
                                                        pagetype={item.pagetype}
                                                    >
                                                        {item.snapshottitle}
                                                    </option>
                                                ))}
                                            </optgroup>
                                        ))}
                                    </Form.Select>

                                    {shotmailsetup?.errorObj?.scheduletype && (
                                        <small className="text-danger">
                                            {shotmailsetup?.errorObj?.snapshotid}
                                        </small>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={6}>
                            <div className="flotingLableGroup">
                                <div className="from-groups no-border-break mb-3">
                                    <Form.Label>Schedule Type</Form.Label>
                                    <Form.Select id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "schedule-type", "")}
                                        aria-label="Default select example"
                                        value={shotmailsetup?.scheduletype}
                                        onChange={(e) => {
                                            setshotmailsetup({
                                                ...shotmailsetup,
                                                scheduletype: e.target.value,
                                                scheduleon: e.target.value === "Daily" ? "Daily" : "",
                                            });
                                        }}
                                    >
                                        <option value="">Schedule Type</option>
                                        <option value="Daily">Daily</option>
                                        <option value="Weekly">Weekly</option>
                                        <option value="Monthly">Monthly</option>
                                    </Form.Select>
                                    {shotmailsetup?.errorObj?.scheduletype && (
                                        <small className="text-danger">
                                            {shotmailsetup?.errorObj?.scheduletype}
                                        </small>
                                    )}
                                </div>
                            </div>
                        </Col>

                        <Col xl={6}>
                            <div className="flotingLableGroup">
                                <div className="from-groups no-border-break mb-3">
                                    <Form.Label>Schedule on</Form.Label>
                                    <Form.Select id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "schedule-on", "")}
                                        aria-label="Default select example"
                                        value={shotmailsetup?.scheduleon}
                                        onChange={(e) => {
                                            setshotmailsetup({
                                                ...shotmailsetup,
                                                scheduleon: e.target.value,
                                            });
                                        }}
                                    >
                                        <option value="">Schedule On</option>
                                        {shotmailsetup.scheduletype === "Daily" && (
                                            <option value="Daily">Daily</option>
                                        )}
                                        {shotmailsetup.scheduletype === "Weekly" && (
                                            <>
                                                <option value="Sunday">Sunday</option>
                                                <option value="Monday">Monday</option>
                                                <option value="Tuesday">Tuesday</option>
                                                <option value="Wednesday">Wednesday</option>
                                                <option value="Thursday">Thursday</option>
                                                <option value="Friday">Friday</option>
                                                <option value="Saturday">Saturday</option>
                                            </>
                                        )}
                                        {shotmailsetup.scheduletype === "Monthly" && (
                                            <>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="Last Day Of Month">
                                                    Last Day Of Month
                                                </option>
                                            </>
                                        )}
                                    </Form.Select>
                                    {shotmailsetup?.errorObj?.scheduleon && (
                                        <small className="text-danger">
                                            {shotmailsetup?.errorObj?.scheduleon}
                                        </small>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={6}>
                            <div className="flotingLableGroup">
                                <div className="from-groups no-border-break mb-3">
                                    <Form.Label>Timezone</Form.Label>
                                    <Form.Select id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "timezone", "")}
                                        aria-label="Default select example"
                                        value={shotmailsetup?.timezone}
                                        onChange={(e) => {
                                            setshotmailsetup({
                                                ...shotmailsetup,
                                                timezone: e.target.value,
                                            });
                                        }}
                                    >
                                        <option value="">Select Timezone</option>
                                        {timeZoneDropDownList.map((item, index) => (
                                            <option value={item.TimeZoneName}>
                                                {item.TimeZoneName} - ({item.UTC_Offset})
                                            </option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </div>
                        </Col>
                        <Col xl={6}>
                            <div className="flotingLableGroup">
                                <div className="from-groups no-border-break mb-3">
                                    <Form.Label>Time</Form.Label>
                                    <Form.Control id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "time", "")}
                                        type="time"
                                        value={shotmailsetup?.runtime || ""}
                                        onChange={(e) =>
                                            setshotmailsetup({
                                                ...shotmailsetup,
                                                runtime: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12}>
                            <div className="table__container">
                                <div className="stripped__table">
                                    <Table id="propertyAssignmentTable">
                                        <thead>
                                            <tr>
                                                <th className="">Send To</th>
                                                <th className="no-search no-sort width100 stickyLastRow text-end">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <Creatable id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "send-to", "")}
                                                        isClearable
                                                        options={userDropdownList}
                                                        placeholder="Select from here or type email"
                                                        onChange={handleChange}
                                                        value={selectedOption}
                                                    />
                                                    {invalidemail && (
                                                        <small className="text-danger">
                                                            {invalidemail}
                                                        </small>
                                                    )}
                                                </td>
                                                <td>
                                                    <button id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "action", "")}
                                                        className="add-btn-plus"
                                                        type="button"
                                                        onClick={() => AddEmail()}
                                                    >
                                                        <img src={addaction} alt="" /> Add
                                                    </button>
                                                </td>
                                            </tr>
                                            {shotmailsetup.sendtolist &&
                                                shotmailsetup.sendtolist.map((item, index) => {
                                                    return (
                                                        <tr>
                                                            <td>{item}</td>
                                                            <td>
                                                                <img id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "deleteicon", item)}
                                                                    src={deleteIcon}
                                                                    alt=""
                                                                    onClick={() => DeleteEmail(item)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>

                            {shotmailsetup?.errorObj?.sendto && (
                                <small className="text-danger">
                                    {shotmailsetup?.errorObj?.sendto}
                                </small>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    {loading ? (
                        <button className="default-btn primary-btn" type="button" disabled>
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Loading...
                        </button>
                    ) : (
                        <button id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "submit", "")}
                            className="default-btn primary-btn"
                            onClick={() => {
                                handleSubmit();
                            }}
                        >
                            Submit
                        </button>
                    )}

                    <Button id={commonService.generateGlobalClickTrackerID("SnapShotMailSetupModal", "cancel", "")} className="default-btn secondary-btn" onClick={closeModal}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SnapShotMailSetupModal;
